import  ExcelJS from 'exceljs'

// ExcelExporter.js
// ExcelExporter.js
export default class ExcelExporter {
  constructor(workbook, title) {
    this.workbook = workbook
    this.title = title
    // 시트가 이미 있으면 가져오고, 없으면 생성
    this.sheet = workbook.getWorksheet(title) || workbook.addWorksheet(title)

    this.rownum = 1 // ExcelJS는 1부터 시작합니다 (POI는 0부터)
    this.cellnum = 1

    // 현재 행과 셀 초기화
    this.currentRow = this.sheet.getRow(this.rownum)
    this.currentCell = this.currentRow.getCell(this.cellnum)
  }

  /**
   * 포인터를 특정 위치로 이동
   * @param {number} rownum 1-based index
   * @param {number} cellnum 1-based index
   */
  jumpTo(rownum, cellnum) {
    this.rownum = rownum
    this.cellnum = cellnum
    this.currentRow = this.sheet.getRow(rownum)
    this.currentCell = this.currentRow.getCell(cellnum)
    return this // 체이닝 지원
  }

  /**
   * 현재 셀에 값을 입력
   * @param {any} value 
   */
  setValue(value) {
    this.currentCell.value = value
    return this
  }

  /**
   * 현재 셀에 스타일을 적용
   */
  setCellStyle(style) {
    this.currentCell.style = style
    return this
  }

  setColWidth(width) {
    // 현재 셀이 속한 컬럼(열)의 너비를 설정
    const col = this.sheet.getColumn(this.currentCell._column._number)
    col.width = width
    return this
  }

  /**
   * 통계/금액용 포맷 설정 (#,##0)
   */
  setCurrencyStyle() {
    this.currentCell.numFmt = '#,##0;\\-#,##0;'
    return this
  }

  /**
   * 소수점 포맷 설정 (0.00)
   */
  setDecimalStyle() {
    this.currentCell.numFmt = '0.00'
    return this
  }

  /**
   * 다음 열로 이동 (cellnum + 1)
   */
  nextCol() {
    // this.cellnum = this.cellnum + 1
    // return this
    return this.jumpTo(this.rownum, this.cellnum + 1)
  }

  /**
   * 다음 행으로 이동 (rownum + 1)
   */
  nextRow() {
    // this.rownum = this.rownum + 1
    // return this
    return this.jumpTo(this.rownum + 1, this.cellnum)
  }
}